<template>
  <div class="date-picker-popup">
    <div class="date-picker-content">
      <div v-if="!showCustom" class="predefined-ranges">
        <button
          v-for="range in predefinedRanges"
          :key="range.value"
          class="range-btn"
          @click="range.value === 'custom' ? showCustomPicker() : selectPredefinedRange(range)"
        >
          {{ range.label }}
        </button>
      </div>

      <div v-if="showCustom" class="custom-range-picker">
        <Datepicker v-model="customDateRange" inline range :auto-apply="true" />
        <div class="actions">
          <button class="btn btn-primary" @click="cancelCustomRange">Cancel</button>
          <button class="btn btn-primary" @click="applyCustomRange">OK</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits } from 'vue';
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

const emit = defineEmits(['update-range', 'close']);
const showCustom = ref(false);
const customDateRange = ref([new Date(), new Date()]);

const predefinedRanges = [
  { label: 'Today', value: 'today' },
  { label: 'Yesterday', value: 'yesterday' },
  { label: 'This week', value: 'this_week' },
  { label: 'Last week', value: 'last_week' },
  { label: 'This month', value: 'this_month' },
  { label: 'Last month', value: 'last_month' },
  { label: 'This year', value: 'this_year' },
  { label: 'Last year', value: 'last_year' },
  { label: 'Custom', value: 'custom' },
];

const showCustomPicker = () => {
  showCustom.value = true;
};

const selectPredefinedRange = (range) => {
  emit('update-range', { type: range.value });
  emit('close');
};

const applyCustomRange = () => {
  if (customDateRange.value.length === 2) {
    const [start, end] = customDateRange.value;
    emit('update-range', { type: 'custom', start, end });
    showCustom.value = false;
    emit('close');
  }
};

const cancelCustomRange = () => {
  showCustom.value = false;
  emit('close');
};
</script>

<style scoped>
.date-picker-popup {
  position: fixed;
  top: 185px;
  right: 10px;
  left: 10px;
  bottom: 5px;
  background: white;
  border: 1px solid #5148da;
  padding: 20px;
  z-index: 2000;
  min-width: 320px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 20px;
}

.date-picker-content {
  display: flex;
  flex-direction: column;
}

.predefined-ranges {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.range-btn {
  margin-bottom: 5px;
  background-color: white;
  color: #8476f4;
  border: 2px solid #8476f4;
  padding: 10px;
  cursor: pointer;
  border-radius: 20px;
  text-align: center;
}

.range-btn:hover {
  background-color: #9e98ea;
}

.custom-range-picker {
  position: relative;
}

.actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.actions .btn {
  margin-left: 10px;
}
</style>
